const updates = [
  { id: 1, date: '2026-07-31', title: '暑期档热门电影专区全新上线', desc: '多部院线大片同步更新至电影在线观看频道，高清画质不缓冲。' },
  { id: 2, date: '2026-07-30', title: '热播电视剧追剧日历更新', desc: '本周电视剧免费频道新增5部热门剧集，每日定时更新最新集数。' },
  { id: 3, date: '2026-07-29', title: '91电影视频专题全新改版', desc: '91电影视频频道页面全面升级，新增分类筛选和智能推荐功能。' },
  { id: 4, date: '2026-07-28', title: '综艺节目精华片段合集发布', desc: '精选近期最火综艺节目爆笑名场面和感动瞬间，综艺迷不容错过。' },
  { id: 5, date: '2026-07-27', title: '麻豆影视在线观看资源更新', desc: '麻豆影视在线观看频道本月新增200+部优质影视视频内容。' },
  { id: 6, date: '2026-07-26', title: '播放体验全面优化升级', desc: '视频加载速度提升30%，进一步确保高清免费不缓冲的流畅观影体验。' },
  { id: 7, date: '2026-07-25', title: '悬疑推理片单专题策划上线', desc: '精心整理高口碑悬疑推理影视视频，满足烧脑爱好者的观影需求。' },
  { id: 8, date: '2026-07-24', title: '最新影视推荐算法优化', desc: '智能推荐系统升级，根据观影偏好更精准地推送你可能喜欢的内容。' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              最新动态
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              天美麻花星空影视免费观看平台运营与内容更新快讯
            </p>
          </div>

          <div className="max-w-3xl mx-auto">
            {updates.map((item, index) => (
              <div key={item.id} className="relative pl-8 pb-8 last:pb-0">
                {index < updates.length - 1 && (
                  <div className="absolute left-[11px] top-7 bottom-0 w-px bg-background-200"></div>
                )}
                <div className="absolute left-0 top-1 w-[23px] h-[23px] rounded-full bg-primary-100 border-2 border-primary-300 flex items-center justify-center">
                  <div className="w-2 h-2 rounded-full bg-primary-500"></div>
                </div>
                <div className="bg-background-100 rounded-xl p-5 border border-background-200/70">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3 mb-2">
                    <span className="text-xs font-medium text-primary-600 whitespace-nowrap">{item.date}</span>
                    <h3 className="text-sm font-heading font-semibold text-foreground-900">{item.title}</h3>
                  </div>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}